import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const s = {
  page: { minHeight:'100vh', background:'var(--paper)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 },
  card: { background:'var(--card)', border:'1px solid var(--line-card)', borderRadius:0, width:'100%', maxWidth:420, overflow:'hidden' },
  header: { background:'var(--ink)', padding:'28px 32px' },
  brand: { fontFamily:'var(--font-display)', color:'var(--paper)', fontSize:20, marginBottom:4 },
  brandSub: { color:'var(--muted-2)', fontSize:12, fontFamily:'var(--font-mono)', letterSpacing:'1px' },
  body: { padding:'32px' },
  title: { fontFamily:'var(--font-display)', fontSize:20, fontWeight:700, marginBottom:6, color:'var(--ink)' },
  sub: { color:'var(--muted)', fontSize:13, marginBottom:28, lineHeight:1.5 },
  group: { marginBottom:18 },
  label: { display:'block', fontSize:11, fontFamily:'var(--font-mono)', letterSpacing:'1px', marginBottom:6, textTransform:'uppercase', color:'var(--muted-2)' },
  input: { width:'100%', padding:'11px 14px', border:'1px solid var(--line)', borderRadius:0, fontSize:14, outline:'none', transition:'border-color 0.15s', fontFamily:'var(--font-body)', background:'var(--card)' },
  btn: { width:'100%', background:'var(--ink)', color:'var(--paper)', border:'none', padding:'13px', fontSize:15, fontWeight:600, borderRadius:0, cursor:'pointer', marginTop:4 },
  footer: { textAlign:'center', marginTop:20, fontSize:13, color:'var(--muted)' },
  link: { color:'var(--ink)', fontWeight:600 },
  error: { background:'var(--card)', border:'1px solid var(--danger)', color:'var(--danger)', padding:'10px 14px', borderRadius:0, fontSize:13, marginBottom:16 },
  note: { fontSize:12, color:'var(--muted)', lineHeight:1.5, marginTop:16, padding:'10px', background:'var(--paper-2)', borderRadius:0 }
};

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    setLoading(true);
    try {
      // Attach first-touch attribution from session storage
      let attribution = null;
      try {
        const stored = sessionStorage.getItem('th_attrib');
        if (stored) attribution = JSON.parse(stored);
      } catch {}
      const { data } = await axios.post('/api/auth/register', { ...form, attribution });
      navigate('/verify-email', { state: { userId: data.userId, email: form.email } });
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card} className="fade-in">
        <div style={s.header}>
          <div style={s.brand}>BioMedArticles</div>
          <div style={s.brandSub}>Clinical Research Platform</div>
        </div>
        <div style={s.body}>
          <h2 style={s.title}>Create account</h2>
          <p style={s.sub}>Free access to 500,000+ clinical trials</p>
          {error && <div style={s.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <div style={s.group}>
              <label style={s.label}>Full Name</label>
              <input style={s.input} type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Dr. Jane Smith" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
            </div>
            <div style={s.group}>
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="you@institution.edu" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
            </div>
            <div style={s.group}>
              <label style={s.label}>Password</label>
              <input style={s.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Min. 6 characters" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
            </div>
            <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
              {loading ? 'Creating account...' : 'Create account →'}
            </button>
          </form>
          <div style={s.note}>📧 A verification code will be sent to your email.</div>
          <div style={s.footer}>
            Already have an account? <Link to="/login" style={s.link}>Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
